module.exports = __webpack_public_path__ + "static/pagamenti-digitali-logo-c4d4aba195d87149111cb89f2cfd1677.gif";